import React from 'react';
import PropTypes from 'prop-types';

import { ANNOTATION_TYPES, ICON_PATH } from '../../../constants';
import './DeleteConfirmation.css';


const ANNOTATION_TYPES_LABEL = Object.freeze({
  [ANNOTATION_TYPES.issue]: 'quality issue',
  [ANNOTATION_TYPES.suggestion]: 'suggestion',
});


const DeleteConfirmation = ({ onCancel, onDelete, type }) => (
  <div className="annotation-delete-confirmation">
    <span className="annotator-heading">
      <img src={`${ICON_PATH}/delete-icon-red.svg`} alt="Delete" className="icon" />
      Delete
      {' '}
      {ANNOTATION_TYPES_LABEL[type]}
      ?
    </span>
    <p className="annotation-item">
      Deleting this
      {' '}
      {ANNOTATION_TYPES_LABEL[type]}
      {' '}
      will permanently
      remove it from this GoCheck.
    </p>
    <button type="button" className="btn" onClick={onCancel}>
      No, keep
      {' '}
      {ANNOTATION_TYPES_LABEL[type]}
    </button>
    <button type="button" className="btn success-btn" onClick={onDelete}>
      Yes, delete
      {' '}
      {ANNOTATION_TYPES_LABEL[type]}
    </button>
  </div>
);


DeleteConfirmation.propTypes = {
  type: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};


export default DeleteConfirmation;
